/* ==========================================================================
   Collection banner cards (snippets/collection-banner.liquid)
   1) <collection-promo-banner>: progi ukrywania wg liczby produktów, wysokość
      karty na mobile, play/pause wideo (sync po window.load i na resize),
   2) drawer czatu Leo (sidebar na desktop, pełny ekran na mobile) + mostek
      koszyka (wspólna flaga __eclatCartBridge z doradcą).
   3) statystyki impression/click do eclat-ab (window.EclatAB), jeśli obecny.
   Ładowany z defer tylko na kolekcjach z bannerami. Konfiguracja (root, język,
   kraj, teksty, tryb edytora) w JSON-ie [data-collection-banner-config].
   ========================================================================== */
/* ==========================================================================
   Statystyki bannerów (eclat-ab). Kontrakt uzgodniony z zespołem A/B:
   placement = handle bannera (data-banner, "cb-…"), variant 'A', split 0.
   - impression: element viewable wg IAB (>=50% powierzchni albo >=50% wysokości
     viewportu) nieprzerwanie przez 1 s; dedupe per (banner, kolekcja, sesja);
     najpierw EclatAB.markExposed (atrybucja ATC/orders), potem 'impression'.
   - click: 'click' z href + dims; dla linku same-origin zapis _eab_nav
     (eclat-ab.js wysyła dest_view na następnej stronie) i flush przed nawigacją.
   - dims: pl, col, cid, ca, ba, bp (m|nm|md|lg), pos, act, row — stringi <=64.
   Brak window.EclatAB (moduł nieobecny, bot, edytor) = moduł nic nie robi.
   ========================================================================== */
var __eclatCbTrack = (function () {
  var AB = window.EclatAB;
  var noop = { observe: function () {}, unobserve: function () {} };
  if (!AB || AB.bot || !AB.vid || (window.Shopify && window.Shopify.designMode)) return noop;

  var VARIANT = 'A', SPLIT = 0, DWELL_MS = 1000;
  var timers = new Map(); // element -> timeout id

  function send(t, h, meta) {
    if (typeof AB.track === 'function') { AB.track(t, h, VARIANT, meta); return; }
    /* eclat-ab.js jeszcze się nie zainicjalizował — surowo do kolejki, którą przejmie */
    (AB._q = AB._q || []).push({ t: t, test: h, variant: VARIANT, ts: Date.now(), meta: meta || {} });
  }
  function flag(key) { try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; } }
  function setFlag(key) { try { sessionStorage.setItem(key, '1'); } catch (e) {} }
  function s64(v) { return String(v == null ? '' : v).slice(0, 64); }
  function bp() {
    var w = window.innerWidth;
    return w < 700 ? 'm' : w < 1000 ? 'nm' : w < 1400 ? 'md' : 'lg';
  }
  function handle(el) { return el.dataset.banner || ''; }
  function dims(el) {
    var d = el.dataset;
    return {
      pl: 'collection_banner',
      col: s64(d.collection),
      cid: s64(d.collectionId),
      ca: s64(d.collectionAudience),
      ba: s64(d.bannerAudience),
      bp: bp(),
      pos: s64(d.bannerIndex),
      act: s64(d.bannerAction),
      row: s64(d.bannerRow)
    };
  }

  function viewable(entry) {
    if (!entry.isIntersecting) return false;
    if (entry.intersectionRatio >= 0.5) return true;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return vh > 0 && entry.intersectionRect.height >= vh * 0.5;
  }
  function fireImpression(el) {
    var h = handle(el);
    if (!h) return;
    var key = '_eab_cbimp_' + h + '_' + (el.dataset.collection || '');
    if (flag(key)) return;
    setFlag(key);
    if (typeof AB.markExposed === 'function') AB.markExposed(h, VARIANT, SPLIT);
    else send('exposure', h, { split: SPLIT });
    send('impression', h, { dims: dims(el) });
  }
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          if (viewable(entry)) {
            if (!timers.has(el)) {
              timers.set(el, setTimeout(function () {
                timers.delete(el);
                io.unobserve(el);
                fireImpression(el);
              }, DWELL_MS));
            }
          } else if (timers.has(el)) {
            clearTimeout(timers.get(el));
            timers.delete(el);
          }
        });
      }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5] })
    : null;

  function onClick(e) {
    var el = e.currentTarget;
    var h = handle(el);
    if (!h || el.dataset.bannerAction === 'none') return; /* nieklikalny banner: tylko impression */
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    var href = (a && el.contains(a)) ? (a.getAttribute('href') || '') : '';
    var key = '_eab_cbclk_' + h + '_' + (el.dataset.collection || '');
    if (!flag(key)) {
      setFlag(key);
      send('click', h, { href: href, dims: dims(el) });
    }
    if (href) {
      try {
        var dest = new URL(href, location.origin);
        if (dest.origin === location.origin) {
          localStorage.setItem('_eab_nav', JSON.stringify({ h: h, v: VARIANT, dest: dest.pathname, t: Date.now() }));
        }
      } catch (err) {}
    }
    if (typeof AB.flush === 'function') AB.flush();
  }

  return {
    observe: function (el) {
      if (!handle(el) || el.__cbTracked) return;
      el.__cbTracked = true;
      el.addEventListener('click', onClick);
      if (io) io.observe(el);
    },
    unobserve: function (el) {
      if (timers.has(el)) { clearTimeout(timers.get(el)); timers.delete(el); }
      if (io) io.unobserve(el);
    }
  };
})();

/* uwaga: nazwa 'collection-promo-banner' — 'collection-banner' jest zajęte
   przez Prestige (hero kolekcji, theme.js) */
if (!customElements.get('collection-promo-banner')) {
  customElements.define('collection-promo-banner', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      __eclatCbTrack.observe(this);
      requestAnimationFrame(function() { self._init(); });
    }

    disconnectedCallback() {
      __eclatCbTrack.unobserve(this);
      if (this._ro) this._ro.disconnect();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    _init() {
      var self = this;
      var list = this.parentElement;
      if (!list) return;
      var card = list.querySelector(':scope > :not(collection-promo-banner):not(link):not(style):not(script)');
      if (!card) return;

      var productCount = list.querySelectorAll(':scope > :not(collection-promo-banner):not(link):not(style):not(script)').length;

      function getColCount() {
        var cols = getComputedStyle(list).gridTemplateColumns;
        if (!cols || cols === 'none') return 2;
        return cols.split(' ').length;
      }

      /* pozycja tego bannera wśród wszystkich, wg rzędu na aktywnym breakpoincie */
      function bannerIndex(isMobile) {
        var attr = isMobile ? 'rowMobile' : 'rowDesktop';
        var all = Array.prototype.slice.call(list.querySelectorAll(':scope > collection-promo-banner'));
        all.sort(function(a, b) { return (+a.dataset[attr] || 0) - (+b.dataset[attr] || 0); });
        return Math.max(0, all.indexOf(self));
      }

      function sync() {
        var cols = getColCount();
        var isMobile = window.innerWidth < 700;
        var row = +(isMobile ? self.dataset.rowMobile : self.dataset.rowDesktop) || 2;
        var k = bannerIndex(isMobile);

        /* 1000–1399px: banner z obrazem mobile zajmuje 2 komórki siatki */
        var span = 1;
        if (!isMobile && window.innerWidth >= 1000 && window.innerWidth < 1400 &&
            self.classList.contains('collection-banner-card--wide-md')) {
          span = 2;
        }

        /* te same progi co pierwotnie:
           mobile  (rzędy 3, 6, …): cols*2, cols*4, …  -> cols * (row - 1 - k)
           desktop (rzędy 2, 4, …): cols*2-1, cols*3-1 -> cols * (row - k) - span
           (span = liczba komórek zajmowanych przez banner; 2 przy 1000–1399px) */
        var minProducts;
        if (isMobile) {
          minProducts = cols * (row - 1 - k);
        } else {
          minProducts = cols * (row - k) - span;
        }

        if (productCount < minProducts) {
          self.style.display = 'none';
          return;
        }
        self.style.display = '';

        if (isMobile) {
          var h = card.offsetHeight;
          if (h > 0) self.style.setProperty('--banner-card-height', h + 'px');
        } else {
          self.style.removeProperty('--banner-card-height');
        }

        /* Play visible videos, pause hidden ones */
        self.querySelectorAll('video').forEach(function(v) {
          if (v.offsetParent !== null) {
            v.play().catch(function() {});
          } else {
            v.pause();
          }
        });
      }

      this._ro = new ResizeObserver(sync);
      this._ro.observe(card);
      this._onResize = sync;
      window.addEventListener('resize', sync);

      if (document.readyState === 'complete') {
        sync();
      } else {
        window.addEventListener('load', sync);
      }

      /* ===== banner czatu: drawer + preconnect na hover ===== */
      var chatBtn = this.querySelector('[data-open-advisor]');
      if (chatBtn) {
        ['pointerenter', 'touchstart', 'focus'].forEach(function(ev) {
          chatBtn.addEventListener(ev, function() {
            if (window.__eclatCbPreconnect) window.__eclatCbPreconnect();
          }, { once: true, passive: true });
        });
        chatBtn.addEventListener('click', function() {
          if (window.__eclatCbOpenDrawer) window.__eclatCbOpenDrawer(chatBtn);
        });
      }
    }
  });
}

/* ===== drawer czatu Leo (singleton) ===== */
(function() {
  if (window.__eclatCbDrawerInit) return;
  window.__eclatCbDrawerInit = true;

  /* konfiguracja ze snippetu: <script type="application/json" data-collection-banner-config> */
  var cfg = {};
  var cfgEl = document.querySelector('[data-collection-banner-config]');
  if (cfgEl) {
    try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { cfg = {}; }
  }
  var HOST = 'https://eclat-scent-advisor.fly.dev'; /* produkcja — ten sam host co snippets/eclat-advisor-collection.liquid */
  var ROOT = cfg.root || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';   /* locale roots come as '/hu-hu' (no slash): cart/add.js appends a path (live review 2026-09-17) */
  var LANG = cfg.lang || document.documentElement.lang || 'en';
  var COUNTRY = cfg.country || '';
  var T_CLOSE = cfg.close || 'Close chat';
  var T_SIGN = cfg.sign || 'Find your signature scent';
  var T_LOADING = cfg.loading || 'Flora is on her way …';
  var DESIGN = cfg.designMode === true;

  var drawer = null, lastFocus = null, scrollY = 0, historyPushed = false, preconnected = false;

  window.__eclatCbPreconnect = function() {
    if (preconnected) return;
    preconnected = true;
    ['preconnect', 'dns-prefetch'].forEach(function(rel) {
      var l = document.createElement('link');
      l.rel = rel; l.href = HOST;
      document.head.appendChild(l);
    });
  };

  function chatContent() {
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:absolute;inset:0';
    if (DESIGN) {
      var ph = document.createElement('div');
      ph.className = 'eclat-cb-skeleton';
      ph.innerHTML = "<strong style='text-transform:uppercase;letter-spacing:.06em;font-weight:400'>" + T_SIGN +
        "</strong><span style='opacity:.7'>Okno czatu działa na sklepie i w podglądzie motywu — edytor blokuje zewnętrzne osadzenia.</span>";
      wrap.appendChild(ph);
      return wrap;
    }
    var skel = document.createElement('div');
    skel.className = 'eclat-cb-skeleton';
    skel.innerHTML = "<span class='pulse'></span><span>" + T_LOADING + "</span>";
    var frame = document.createElement('iframe');
    frame.title = T_SIGN;
    frame.src = HOST + '/?embed=1&mode=section&lang=' + encodeURIComponent(LANG) +
      '&country=' + encodeURIComponent(COUNTRY) + '&root=' + encodeURIComponent(ROOT) +
      '&host=' + encodeURIComponent(location.origin);
    frame.src += '&page=' + encodeURIComponent(location.pathname.slice(0, 120));   /* Leo 2.0 analytics: the shop page */
    var sidMem = (window.eclatChat && window.eclatChat.sid()) || null;   /* travelling chat: continue the session from any entry point */
    if (sidMem) frame.src += '&sid=' + encodeURIComponent(sidMem);
    try { var _en = String(new URLSearchParams(location.search).get('chat') || (location.hash.match(/eclat-chat=([A-Za-z_-]{1,20})/) || [])[1] || '').toLowerCase().replace(/[^a-z_-]/g, '').slice(0, 20);
          if (_en) frame.src += '&intent=' + encodeURIComponent(_en); } catch (e) {}   /* entry points (marketing 2026-10-01) */
    frame.referrerPolicy = 'strict-origin';
    frame.addEventListener('load', function() {
      skel.style.opacity = '0';
      setTimeout(function() { skel.remove(); }, 250);
    });
    wrap.appendChild(frame);
    wrap.appendChild(skel);
    return wrap;
  }

  var scrollLocked = false;   /* owner 2026-10-08: the position is restored only when it was locked; a second open never overwrites it */
  function lockScroll() {
    if (scrollLocked) return;
    scrollLocked = true;
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function build() {
    drawer = document.createElement('div');
    drawer.className = 'eclat-cb-drawer';

    var backdrop = document.createElement('div');
    backdrop.className = 'eclat-cb-drawer__backdrop';
    backdrop.addEventListener('click', close);

    var panel = document.createElement('div');
    panel.className = 'eclat-cb-drawer__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', T_SIGN);

    var head = document.createElement('div');
    head.className = 'eclat-cb-drawer__head';
    var t = document.createElement('span');
    t.className = 'eclat-cb-drawer__title';
    t.innerHTML = '<strong>ÉCLAT</strong><small>' + T_SIGN + '</small>';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'eclat-cb-drawer__close';
    x.setAttribute('aria-label', T_CLOSE);
    x.textContent = '×';
    x.addEventListener('click', close);
    head.appendChild(t);
    head.appendChild(x);

    var body = document.createElement('div');
    body.className = 'eclat-cb-drawer__body';
    body.appendChild(chatContent());

    panel.appendChild(head);
    panel.appendChild(body);
    drawer.appendChild(backdrop);
    drawer.appendChild(panel);
    document.body.appendChild(drawer);
  }

  function onKeydown(e) { if (e.key === 'Escape') close(); }

  function open(btn) {
    lastFocus = btn || null;
    window.__eclatCbPreconnect();
    if (!drawer) {
      build();
      /* klatka startowa przed dodaniem klasy — inaczej brak animacji wejścia */
      drawer.getBoundingClientRect();
    }
    drawer.classList.add('is-open');
    if (window.eclatChat) window.eclatChat.setOpen(true);
    lockScroll();
    document.addEventListener('keydown', onKeydown);
    if (window.innerWidth < 700) {
      try { history.pushState({ eclatCb: true }, ''); historyPushed = true; } catch (e) {}
    }
    var x = drawer.querySelector('.eclat-cb-drawer__close');
    if (x) x.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (window.eclatChat) window.eclatChat.setOpen(false);
    unlockScroll();
    document.removeEventListener('keydown', onKeydown);
    if (historyPushed) { historyPushed = false; try { history.back(); } catch (e) {} }
    if (lastFocus) lastFocus.focus();
  }

  window.addEventListener('popstate', function() {
    if (historyPushed) { historyPushed = false; close(); }
  });

  window.__eclatCbOpenDrawer = open;

  /* the drawer takes part in the travelling chat: it remembers the session the widget reports, forgets it on 'New chat'
     and closes on the widget's own close message (owner 2026-09-18) */
  window.addEventListener('message', function (e) {
    if (e.origin !== new URL(HOST).origin) return;
    var d = e.data || {};
    if (d.type === 'eclat:session' && d.sessionId && window.eclatChat) window.eclatChat.remember(String(d.sessionId).slice(0, 64));
    if (d.type === 'eclat:session-reset' && window.eclatChat && window.eclatChat.forget) window.eclatChat.forget();
    if (d.type === 'eclat-advisor-close') close();
  });

  /* ===== mostek koszyka — identyczny jak w doradcy (wspólna flaga) ===== */
  if (!window.__eclatCartBridge) {
    window.__eclatCartBridge = true;
    var BASE = new URL(HOST).origin;
    window.addEventListener('message', async function(e) {
      if (e.origin !== BASE) return;
      var d = e.data || {};
      if (d.type !== 'eclat:add-to-cart' && d.type !== 'eclat:add-items') return;
      var reply = function(ok, error) {
        e.source.postMessage({ type: 'eclat:cart-result', variantId: d.variantId, ok: ok, error: error }, e.origin);
      };
      /* atrybucja: property z "_" jest ukryta przed klientem, ale wedruje na zamowienie -> Shopify Flow taguje je "chat-advisor" */
      var props = { _chat_advisor: 'leo' };
      if (d.sessionId) props._chat_session = String(d.sessionId).slice(0, 64);
      var items;
      if (d.type === 'eclat:add-items') {
        /* KI-Box (Leo 2.0): several lines in one call, tagged with one _bundleId like the shop's own set builder */
        var bundleId = String(Date.now());
        items = (Array.isArray(d.items) ? d.items : []).slice(0, 12).map(function (it) {
          var id = parseInt(it && it.variantId, 10);
          var qn = Math.min(Math.max(1, parseInt(it && it.quantity, 10) || 1), 10);
          return (Number.isInteger(id) && id > 0) ? { id: id, quantity: qn, properties: Object.assign({ _bundleId: bundleId }, props) } : null;
        }).filter(Boolean);
        if (!items.length) { reply(false, 'invalid items'); return; }
      } else {
        var vid = parseInt(d.variantId, 10);
        var qty = Math.min(Math.max(1, parseInt(d.quantity, 10) || 1), 10);
        if (!Number.isInteger(vid) || vid <= 0) { reply(false, 'invalid variant'); return; }
        items = [{ id: vid, quantity: qty, properties: props }];
      }
      try {
        var res = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
        if (res.ok) {
          /* sygnal sesji na calym koszyku (fallback dla Flow); blad ignorujemy */
          fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ attributes: Object.assign({ chat_advisor: 'leo' }, d.sessionId ? { chat_session: String(d.sessionId).slice(0, 64) } : {}) })
          }).catch(function() {});
        }
        if (res.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          reply(true);
        } else {
          var body = await res.json().catch(function() { return {}; });
          reply(false, body.description || body.message);
        }
      } catch (err) { reply(false, String(err)); }
    });
  }
})();
